import firebase from "firebase/compat/app"
import "firebase/compat/storage"
import "firebase/compat/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyBNkP7f5e7DyOfrpxGcZmRz2gq-6wRoyY8",
  authDomain: "csi-website-8c60b.firebaseapp.com",
  databaseURL: "https://csi-website-8c60b-default-rtdb.firebaseio.com",
  projectId: "csi-website-8c60b",
  storageBucket: "csi-website-8c60b.appspot.com",
  messagingSenderId: "384019508623",
  appId: "1:384019508623:web:98431caaa843b8d699effa"
}

firebase.initializeApp(firebaseConfig)

// Use these for db & auth
const firestore = firebase.firestore()

/* eslint-disable import/prefer-default-export */
export const database = {
  gallery: firestore.collection("gallery"),
  home_carousel: firestore.collection("home_carousel"),
  team: firestore.collection("team"),
  testimonial: firestore.collection("testimonial"),
  slides: firestore.collection("slides")
}
